import {
  KEYCODE_MAP,
  KEYCODE_MACRO_MAP,
} from "@eweadn-qiankun/shared-components";
import {
  hfdMagneticDksTrpsToBinaryData,
  tank68heDksBinaryDataToTrps,
  xingshanDksBinaryDataToTrps,
  xingshanDksTrpsToBinaryData,
} from "@eweadn-qiankun/shared-utils";

const DKS_TRIGGER_SLOT_COUNT = 4;

/** tank68he 专用：华奋达磁轴四点 DKS trps 编解码（其它型号仍走星闪 8 点） */
export const isTank68HeDksCodec = (keyboardType?: string | null): boolean =>
  String(keyboardType ?? "").trim() === "tank68he";

export const resolveDksTriggerKeyCode = (item: {
  keyCode?: unknown;
}): number => {
  const raw = Number(item?.keyCode);
  return Number.isFinite(raw) && raw > 0 ? raw : 0;
};

const keyCodeLabel = (kc: number): string =>
  KEYCODE_MAP[kc]?.name || KEYCODE_MACRO_MAP[kc]?.name || "";

/** 保存前：固定 4 槽 kcs/trps（空槽 keyCode=0、trps=0） */
export function buildDksPayloadKcsTrps(
  triggerData: Array<{ keyCode?: unknown; binaryData?: unknown[] }>,
  useTank68HeDksCodec: boolean
): { kcs: number[]; trps: number[] } {
  const kcs: number[] = [];
  const trps: number[] = [];
  for (let i = 0; i < DKS_TRIGGER_SLOT_COUNT; i++) {
    const item = triggerData[i] ?? {};
    const kc = resolveDksTriggerKeyCode(item);
    kcs.push(kc);
    if (kc <= 0) {
      trps.push(0);
      continue;
    }
    trps.push(
      useTank68HeDksCodec
        ? tank68heDksBinaryDataToTrps(item.binaryData as never)
        : xingshanDksBinaryDataToTrps(item.binaryData as never)
    );
  }
  return { kcs, trps };
}

/** 读回/编辑：由固件 kcs+trps 填充 4 槽 triggerData */
export function applyDksTriggerDataFromPayload(
  triggerDataTemplate: Array<{ binaryData?: unknown[] }>,
  kcs: number[],
  trps: number[],
  useTank68HeDksCodec: boolean
) {
  return Array.from({ length: DKS_TRIGGER_SLOT_COUNT }, (_, k) => {
    const template = triggerDataTemplate[k] ?? {};
    const copyBinaryData = JSON.parse(
      JSON.stringify(template.binaryData ?? [])
    ) as Array<{ check?: boolean; value?: number; [key: string]: unknown }>;
    const kc = Number(kcs[k] ?? 0);
    if (!(kc > 0)) {
      return {
        code: "",
        uuid: "",
        col: "",
        label: "",
        row: "",
        keyCode: "",
        check: false,
        binaryData: copyBinaryData.map((entry) => ({
          ...entry,
          check: false,
          value: 0,
        })),
      };
    }
    const trpsData = Number(trps[k] ?? 0);
    const binaryData = useTank68HeDksCodec
      ? hfdMagneticDksTrpsToBinaryData(trpsData, copyBinaryData)
      : xingshanDksTrpsToBinaryData(trpsData, copyBinaryData);
    return {
      uuid: null,
      col: null,
      label: keyCodeLabel(kc),
      row: null,
      keyCode: kc,
      check: false,
      binaryData,
    };
  });
}
